import React from 'react';
import { Group } from '../../../primitives/Group/Group.es.js';
import PaginationButton from './PaginationButton.es.js';

var Truncated = function Truncated(_ref) {
  var buttonComponent = _ref.buttonComponent,
      startRange = _ref.startRange,
      endRange = _ref.endRange,
      currentPage = _ref.currentPage,
      buttonSize = _ref.buttonSize,
      shape = _ref.shape,
      goToPage = _ref.goToPage;
  return (
    /* @__PURE__ */
    React.createElement(React.Fragment, null, startRange.map(function (page, i) {
      return (
        /* @__PURE__ */
        React.createElement(PaginationButton, {
          buttonComponent: buttonComponent,
          key: "" + i + page,
          isSelected: currentPage === page,
          buttonSize: buttonSize,
          shape: shape,
          page: page,
          onClick: function onClick() {
            return goToPage(page);
          },
          itemType: "number"
        }, page)
      );
    }),
    /* @__PURE__ */
    React.createElement(Group.Item, null,
    /* @__PURE__ */
    React.createElement(PaginationButton, {
      buttonComponent: buttonComponent,
      buttonSize: buttonSize,
      shape: shape,
      itemType: "ellipsis"
    }, "...")), endRange.map(function (page, i) {
      return (
        /* @__PURE__ */
        React.createElement(PaginationButton, {
          buttonComponent: buttonComponent,
          key: "" + i + page,
          isSelected: currentPage === page,
          buttonSize: buttonSize,
          shape: shape,
          page: page,
          onClick: function onClick() {
            return goToPage(page);
          },
          itemType: "number"
        }, page)
      );
    }))
  );
};

export { Truncated as default };